(function(){
  if(window.__chAnim) return;
  window.__chAnim = true;

  function reveal(){
    if(!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.ch-wrap > *, .ch-cta > *');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(targets, function(el, i){
      if(el.closest('.ch-hd') || el.closest('.ch-dw')) return;
      el.classList.add('ch-reveal');
      el.style.animationDelay = Math.min(i % 4, 3) * 60 + 'ms';
      io.observe(el);
    });
  }

  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"></path><path d="M9 7V5h6v2"></path><path d="M6 7l1 13h10l1-13"></path><path d="M10 11v6M14 11v6"></path></svg>';

  function addTrash(){
    var host = document.querySelector('[data-dw-lines]');
    if(!host) return;
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    function decorate(){
      host.querySelectorAll('.ch-dw__lrow').forEach(function(row){
        if(row.querySelector('.ch-dw__rm')) return;
        var stp = row.querySelector('.ch-dw__stp');
        if(!stp) return;
        var btn = stp.querySelector('[data-dw-chg]');
        if(!btn) return;
        var line = btn.getAttribute('data-dw-chg');
        var wrap = document.createElement('span');
        wrap.className = 'ch-dw__qtywrap';
        stp.parentNode.insertBefore(wrap, stp);
        wrap.appendChild(stp);
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'ch-dw__rm';
        rm.setAttribute('aria-label', 'Remove item');
        rm.setAttribute('data-dw-remove', line);
        rm.innerHTML = TRASH;
        wrap.appendChild(rm);
      });
    }

    new MutationObserver(decorate).observe(host, { childList: true, subtree: true });
    decorate();

    document.addEventListener('click', function(e){
      var rm = e.target.closest('[data-dw-remove]');
      if(!rm) return;
      e.preventDefault();
      e.stopPropagation();
      var line = parseInt(rm.getAttribute('data-dw-remove'), 10);
      rm.disabled = true;
      var dw = document.getElementById('ch-drawer');
      if(dw) dw.classList.add('is-busy');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function(){
        if(window.CHCart && window.CHCart.refresh) return window.CHCart.refresh();
      }).then(function(){
        if(dw) dw.classList.remove('is-busy');
      }).catch(function(){
        if(dw) dw.classList.remove('is-busy');
        rm.disabled = false;
      });
    }, true);
  }

  function boot(){ reveal(); addTrash(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
